import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { CassError } from '@core/models/cass-error';
import { Logger } from '@core/services/logger.service';
import { PaymentGatewayFormRequest } from '@order/models/payment-gateway-form-request';
import { PaymentGatewayFormResponse } from '@order/models/payment-gateway-form-response';
import { DOCUMENT } from '@angular/common';

const PAYMENT_GATEWAY_URL = "https://payment.paytrail.com/e2";

export enum PaymentGatewayCode {
	PAYTRAIL_LEGACY = "paytrail",
	PAYTRAIL_2022 = "paytrail2022"
}

@Injectable({
	providedIn: 'root'
})
export class PaymentGatewayPaytrailService {

	private readonly COMPONENT_NAME = "PaymentGatewayPaytrailService";

	constructor(
		private http: HttpClient,
		private location: Location,
		private logger: Logger,
		@Inject(DOCUMENT) private document: Document) { }

	proceedToPayment(orderId: string, gateway: PaymentGatewayCode): Promise<void> {
		const promise = new Promise<void>((resolve, reject) => {
			const url = BackendAPI.paymentForm;
			const baseUrl = window.location.origin;

			const urlSuccess = Location.joinWithSlash(baseUrl, this.location.prepareExternalUrl("/paymentResult?result=success"));
			const urlCancel = Location.joinWithSlash(baseUrl, this.location.prepareExternalUrl("/paymentResult?result=cancel"));
			const urlApiBase = Location.joinWithSlash(baseUrl, this.location.prepareExternalUrl(BackendAPI.base));

			const request = new PaymentGatewayFormRequest(orderId, gateway, urlApiBase);
			request.setParameter("urlSuccess", urlSuccess);
			request.setParameter("urlCancel", urlCancel);

			this.http.post<PaymentGatewayFormResponse>(url, request).subscribe(
				(paymentInfo) => {
					if (gateway === PaymentGatewayCode.PAYTRAIL_LEGACY && paymentInfo && paymentInfo.formfields) {
						this.submitPaymentForm(paymentInfo.formfields);
						resolve();
					}
					else if (gateway === PaymentGatewayCode.PAYTRAIL_2022 && paymentInfo && paymentInfo.redirectUrl) {
						this.document.location.href = paymentInfo.redirectUrl;
						resolve();
					}
					else {
						this.logger.error(this.COMPONENT_NAME, "Invalid parameters received from the backend", JSON.stringify(paymentInfo));
						reject(CassError.createErrorWithMessageKey("ERRORS.CANNOT_RETRIEVE_PAYMENT_INFO"));
					}
				},
				(error) => {
					this.logger.error(this.COMPONENT_NAME, "Payment gateway failed", error);
					reject(error);
				});
		})

		return promise;
	}

	private submitPaymentForm(formFields: any): void {
		const form = this.document.createElement('form');
		form.method = 'POST';
		form.action = PAYMENT_GATEWAY_URL;
		this.document.body.appendChild(form);

		for (const prop in formFields) {
			const hiddenField = this.document.createElement("input");
			hiddenField.setAttribute("type", "hidden");
			hiddenField.setAttribute("name", prop);
			hiddenField.setAttribute("value", formFields[prop]);
			form.appendChild(hiddenField);
		}

		form.submit();
	}
}
